module.exports = __webpack_public_path__ + "static/media/mw.d6915440.svg";